import React from "react";

const StatCard = ({ value, label }) => {
  return (
    <div className="text-center px-6 py-8 rounded-2xl bg-white border border-gray-100 shadow-sm">
      <div className="font-heading font-extrabold text-3xl md:text-4xl text-p3-navy mb-2">{value}</div>
      <div className="text-sm text-p3-muted">{label}</div>
    </div>
  );
};

export default StatCard;
